import { render } from "./DiscountTreeTransfer.vue?vue&type=template&id=7358d323&scoped=true"
import script from "./DiscountTreeTransfer.vue?vue&type=script&lang=js"
export * from "./DiscountTreeTransfer.vue?vue&type=script&lang=js"

import "./DiscountTreeTransfer.vue?vue&type=style&index=0&id=7358d323&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7358d323"]])

export default __exports__